module.exports = "<div class=\"back-white\"></div>\n"